import React, { useEffect, useState } from 'react';
import { useAddCalendarMeetingNotesMutation } from '../../api/calendar.js';
import BaseInput from '../../components/form/BaseInput.jsx';
import BaseOverlay from '../../components/layout/BaseOverlay.jsx';
import MeetingListItem from '../../components/misc/MeetingListItem.jsx';
import { useErrorToast } from '../../hooks/useToast.jsx';
import BaseButton from '../form/BaseButton.jsx';

const MeetingNotesEdit = ({ calendarMeetingId, editButtonText, notes, notesType }) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [note, setNote] = useState('');
    const [notesState, setNotesState] = useState([]);

    const [addCalendarMeetingNotes, { isLoading, error }] = useAddCalendarMeetingNotesMutation();

    const editNotes = () => {
        setShowOverlay(true);
        setNotesState([...notes]);
    };

    const closeOverlay = () => {
        setShowOverlay(false);
    };

    const addNote = (e) => {
        if (e.key === 'Enter' && note !== '') {
            setNotesState([...notesState, { id: Date.now().toString(), text: note }]);
            setNote('');
        }
    };

    const editNote = (index, updatedText) => {
        const updatedNotes = notesState.map((note, i) => (i === index ? { ...note, text: updatedText } : note));
        setNotesState(updatedNotes);
    };

    const removeNote = (index) => {
        const updatedNotes = notesState.filter((_, i) => i !== index);
        setNotesState(updatedNotes);
    };

    const renderNotes = () => {
        return notesState.map(({ id, text }, index) => (
            <MeetingListItem
                key={id}
                text={text}
                onDelete={() => removeNote(index)}
                onEdit={(updatedText) => editNote(index, updatedText)}
                editable
            />
        ));
    };

    useEffect(() => {
        if (error) {
            useErrorToast(error?.data?.message || 'An error occurred while saving the notes.');
        }
    }, [error]);

    const appendNotes = async () => {
        const requestData =
            notesType === 'objectives'
                ? { objectives: notesState.map((note) => note.text) }
                : { obstacles: notesState.map((note) => note.text) };

        await addCalendarMeetingNotes({ id: calendarMeetingId, data: requestData, notesType });
        closeOverlay();
    };

    return (
        <>
            <BaseButton className='mt-4 btn-red-outline' onClick={editNotes} textValue={editButtonText} />

            <BaseOverlay show={showOverlay} className='overflow-auto h-[100dvh] rounded-none'>
                <div className='min-h-96 max-w-3xl w-full mx-auto px-8'>
                    <div className='flex justify-end py-4'>
                        <div className='text-theme1-primary font-bold' onClick={closeOverlay}>
                            Close
                        </div>
                    </div>
                    <div className='text-center text-theme1-title2 font-bold text-[22px] mb-3'>
                        {notesType === 'objectives' ? 'Objectives' : 'Obstacles'}
                    </div>

                    <div className='mb-4'>
                        <BaseInput
                            type='text'
                            placeholder={`Add ${notesType === 'objectives' ? 'Objective' : 'Obstacle'}`}
                            name='note'
                            value={note}
                            setValue={(value) => setNote(value)}
                            onKeyDown={addNote}
                        />
                    </div>
                    <div className='flex items-center flex-col'>{renderNotes()}</div>
                    <BaseButton
                        className='mt-4 btn-red-outline'
                        onClick={appendNotes}
                        textValue={isLoading ? 'Saving...' : 'Save changes'}
                        disabled={isLoading}
                    />
                </div>
            </BaseOverlay>
        </>
    );
};

export default MeetingNotesEdit;
